import {
    INCREASE_REPORTS_CLEARED,
    INCREASE_REPORTS_FETCHED,
    INCREASE_REPORTS_FETCHING_CHANGED,
    INCREASE_REPORTS_FILTERS_DATES_CHANGED,
    INCREASE_REPORTS_FILTERS_STATUS_CHANGED,
    INCREASE_REPORTS_HAS_MORE_CHANGED,
    INCREASE_REPORTS_PAGE_CHANGED,
    INCREASE_REPORTS_PAGINATED,
    INCREASE_REPORTS_PAGINATING_CHANGED,
} from '../actions/types';
import { REPORT_FILTER_PERIODS, INCREASE_REPORT_STATUSES } from '../../constants/defaultValues';

const initialState = {
    reports: [],
    isFetching: false,
    isPaginating: false,
    selectedPeriod: REPORT_FILTER_PERIODS[0].key,
    dates: { createStartDate: null, createEndDate: null },
    selectedStatus: INCREASE_REPORT_STATUSES[0].id,
    currentPage: 1,
    hasMore: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case INCREASE_REPORTS_FETCHED: {
            return { ...state, reports: payload, isFetching: false };
        }
        case INCREASE_REPORTS_PAGINATED: {
            return { ...state, reports: state.reports.concat(payload), isPaginating: false };
        }
        case INCREASE_REPORTS_CLEARED: {
            return { ...state, reports: [] };
        }
        case INCREASE_REPORTS_FETCHING_CHANGED: {
            return { ...state, isFetching: payload };
        }
        case INCREASE_REPORTS_PAGINATING_CHANGED: {
            return { ...state, isPaginating: payload };
        }
        case INCREASE_REPORTS_FILTERS_DATES_CHANGED: {
            return { ...state, dates: { ...state.dates, ...payload } };
        }
        case INCREASE_REPORTS_FILTERS_STATUS_CHANGED: {
            return { ...state, selectedStatus: payload };
        }
        case INCREASE_REPORTS_PAGE_CHANGED: {
            return { ...state, currentPage: payload };
        }
        case INCREASE_REPORTS_HAS_MORE_CHANGED: {
            return { ...state, hasMore: payload };
        }
        default:
            return state;
    }
}
